// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stay-details.collapsed .show-less[data-v-36dd07ad] {\n    display: none;\n}\n.stay-details:not(.collapsed) .show-more[data-v-36dd07ad] {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
